// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pemjkmuyskhnljayweiu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbWprbXV5c2tobmxqYXl3ZWl1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE1MTcyNDUsImV4cCI6MjA1NzA5MzI0NX0.r4LzUzuz0fcrfFsRNnSdJP0gxfbP-cRvu3ElR8CseVM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
